import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { paybill_lange } from "../../language/paybill";
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
defineLocale('enGb', enGbLocale);
defineLocale('th', thLocale);
declare var report_url;
declare var url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class paybill {
  invoice_id: string;
  fee_id: string;
  fee_description: string;
  customer_id: string;
  customer_name: string;
  address: string;
  user_id: string;
  create_datetime: string;
  due_date: string;
  fee_price: string;
  total_price: string;
  check: string;
}

@Component({
  selector: 'app-paybill',
  templateUrl: './paybill.component.html',
  styleUrls: ['./paybill.component.scss']
})
export class PaybillComponent implements OnInit {
  actions = [
    { id: 0, action_type: { TH: "แสดงรายการการค้างชำระ", EN: "Invoice Data" } },
    { id: 1, action_type: { TH: "ชำระเงิน", EN: "Pay" } },

  ]
  daysInmonth;
  days;
  type = 2;
  day = new Date().getDay() + 1;
  month = new Date().getMonth() + 1;
  year = new Date().getFullYear();
  years: any;
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  isLoading = true;
  action = this.actions[0];
  vat_price = 0;
  payments: any;
  submitted = false;
  paytype = "";
  check_payment = "2";
  total_price: any;
  discount = 0;
  remark = "";
  sum = 0;
  payment_id = "";
  municipality_id = "";
  token = '';
  database = '';
  dtOptions: DataTables.Settings = {};
  paybills: paybill[];
  selected_items = [];
  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService) {
    this.language = paybill_lange[this.lang];
  }

  user: any
  ngOnInit() {
    if (parseInt(this.year.toString()) < 2500) {
      this.year = this.year + 543;
    }

    this.years = [];
    for (var i = 0; i < 5; i++) {
      this.years.push(this.year - i);
    }

    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }
    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }

    if (sessionStorage.getItem('municipality') != undefined) {
      this.database = JSON.parse(sessionStorage.getItem('municipality')).municipality_id + '_fee'
    }

    if (sessionStorage.getItem('token') != undefined) {
      this.token = sessionStorage.getItem('token');
    }

    console.log(localStorage.getItem('month') + ' ' + localStorage.getItem('year'));
    if (localStorage.getItem('month') == 'null') {
      var month;
      if (localStorage.getItem('month').length > 1) {
        month = (localStorage.getItem('month')).match(/"([^']+)"/)[1];
      } else {
        month = localStorage.getItem('month');
      }
      var year = localStorage.getItem('year');

      this.isLoading = false;
      const that = this;
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10,
        serverSide: true,
        processing: true,
        language: {
          emptyTable: 'NO Records',
          zeroRecords: '',
        },
        ajax: (dataTablesParameters: any, callback) => {
          console.log('invoice/get-invoice_to_datatable')
          that.http
            .post<DataTablesResponse>(
              url + 'invoice/get-invoice_to_datatable',
              dataTablesParameters, {
              headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=utf-8',
                'x-access-token': this.token,
                'database': this.database,
                'municipality_id': this.municipality_id,
                'day': (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(),
                'year': year,
                'month': month,
                'dashboard': 'false'
              })
            }
            ).subscribe(resp => {
              //debugger 
              that.paybills = resp.data.map((item) => {
                var xy = 0;
                xy = parseInt(moment(item.create_datetime).format('YYYY'));

                if (xy < 2500) {
                  xy = xy + 543;
                }

                item.create_datetime = moment(item.create_datetime).format("DD/MM/") + xy;

                xy = 0;
                xy = parseInt(moment(item.due_date).format('YYYY'));

                if (xy < 2500) {
                  xy = xy + 543;
                }

                item.due_date = moment(new Date(item.due_date)).format("DD/MM/") + xy;
                item.check = false;

                if (that.lang == 'TH') {
                  item.address = item.place_address + ' ' + item["tambon_th"] + ' ' + item["amphur_th"] + ' ' + item["province_th"];
                }
                else {
                  item.address = item.place_address + ' ' + item["tambon_en"] + ' ' + item["amphur_en"] + ' ' + item["province_en"];
                }

                return item;
              });
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });

              localStorage.removeItem('month');
              localStorage.removeItem('year');
            });
        },
        columns: [{ data: 'b.invoice_id' }, { data: 'b.fee_id' }, { data: 'ft.fee_type_description' }, { data: 'f.customer_id' }, { data: 'c.customer_name' }, { data: 'cp.place_address' }, { data: 'b.user_id' }, { data: 'to_char(b.create_datetime,\'YYYY-MM-DD\')' }, { data: 'to_char(b.due_date,\'YYYY-MM-DD\')' }
          , { data: 'b.fee_price :: varchar' }, { data: 'b.total_price :: varchar' }, { data: '' }]

      };

    } 
    else {
      this.isLoading = false;
      const that = this;
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10,
        serverSide: true,
        processing: true,
        language: {
          emptyTable: 'NO Records',
          zeroRecords: '',
        },
        ajax: (dataTablesParameters: any, callback) => {
          console.log('invoice/get-invoice_to_datatable')
          that.http
            .post<DataTablesResponse>(
              url + 'invoice/get-invoice_to_datatable',
              dataTablesParameters, {
              headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=utf-8',
                'x-access-token': this.token,
                'database': this.database,
                'municipality_id': this.municipality_id
              })
            }
            ).subscribe(resp => {
              //debugger 
              that.paybills = resp.data.map((item) => {
                var xy = 0;
                xy = parseInt(moment(item.create_datetime).format('YYYY'));

                if (xy < 2500) {
                  xy = xy + 543;
                }

                item.create_datetime = moment(item.create_datetime).format("DD/MM/") + xy;

                xy = 0;
                xy = parseInt(moment(item.due_date).format('YYYY'));

                if (xy < 2500) {
                  xy = xy + 543;
                }

                item.due_date = moment(new Date(item.due_date)).format("DD/MM/") + xy;
                item.check = false;

                if (that.lang == 'TH') {
                  item.address = item.place_address + ' ' + item["tambon_th"] + ' ' + item["amphur_th"] + ' ' + item["province_th"];
                }
                else {
                  item.address = item.place_address + ' ' + item["tambon_en"] + ' ' + item["amphur_en"] + ' ' + item["province_en"];
                }

                return item;
              });
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            });
        },
        columns: [
          { data: 'b.invoice_id' },
          { data: 'b.fee_id' },
          { data: 'ft.fee_type_description' }, { data: 'f.customer_id' }, { data: 'c.customer_name' }, { data: 'cp.place_address' }, { data: 'b.user_id' }, { data: 'to_char(b.create_datetime,\'DD/MM/YYYY\')' }, { data: 'to_char(b.due_date,\'DD/MM/YYYY\')' }
          , { data: 'b.fee_price :: varchar' }, { data: 'b.total_price :: varchar' }, { data: '' }]

      };
    }



    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = paybill_lange[this.lang];
        this.localeService.use(this.lang.toLowerCase());
      } else {
        this.localeService.use(params['lang'].toLowerCase());
        this.language = paybill_lange[params['lang']];
        localStorage.setItem('lang', params['lang']);
      }
    });
  }

  print_invoice(invoice) {
    const municipality_id = this.service.getDatabase().substring(0, 5);
    const invoice_id = invoice.invoice_id;
    this.service.postData({ invoice_id }, "invoice/print-invoice").then((result) => {
      window.open(report_url + "print-invoice?invoice_id=" + invoice_id + "&municipality_id=" + municipality_id, "_blank");
    })
  }

  hasSelected() {
    if (this.paybills == undefined) {
      return false;
    }
    else {
      return this.paybills.filter((item) => item.check).length > 0;
    }
  }

  check(invoice) {
    invoice.check = !invoice.check;
  }

  formatDate(date) {
    var monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var hour = date.getHours();
    var min = date.getMinutes();
    var sec = date.getSeconds();
    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }

  delete(bill) {
    Swal.fire({
      title: this.language.confirm_delete,
      text: this.language.warining_delete,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.language.want_delete,
      cancelButtonText: this.language.close
    }).then((result) => {
      if (result.value) {

        this.service.postData({ invoice_id: bill.invoice_id }, "invoice/cancel-invoice").then(result => {
          this.isLoading = false;
          Swal.fire({
            title: this.language.deleted,
            text: '',
            type: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000
          }).then((result) => {
            this.action = this.actions[0];
          })
        }, err => {
          Swal.fire({
            title: this.language.no_internet_alert,
            text: '',
            type: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000
          });
          this.isLoading = false;
        })
      }
    });
  }

  update() {
    var customer_id = ''
    this.isLoading = true;
    this.selected_items = this.paybills.filter((item) => item.check);
    console.log(this.selected_items);
    if (this.selected_items.length > 0) {
      customer_id = this.selected_items[0].customer_id;
    }

    this.sum = 0;
    this.selected_items.forEach((item) => {
      this.sum += parseInt(item.total_price);
      if (customer_id != item.customer_id) {
        customer_id = 'error';
        Swal.fire({
          title: this.language.customer_not_same,
          text: '',
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        });
      }
    });

    if (customer_id != 'error') {
      this.action = this.actions[1];
      this.service.postData({}, "payment-type/get").then((result: any) => {
        this.payments = result.data;
        this.isLoading = false;
      }, err => {
        this.action = this.actions[0];
      })
    }
    else {
      this.isLoading = false;
    }

  }

  cancel() {
    this.action = this.actions[0];
  }

  pay() {

    this.submitted = true;
    if (this.isFloat(this.discount) && this.payment_id != "") {
      Swal.fire({
        title: this.language.confirm_update,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.language.want_update,
        cancelButtonText: this.language.close
      }).then((result) => {
        debugger
        let totalPriceSum = 0
        for (let i = 0; i < this.selected_items.length; i++) {
          const price = this.selected_items[i];
          totalPriceSum += parseInt(price.fee_price)
        }
        totalPriceSum = (totalPriceSum - this.discount)
        if (result.value) {
          this.isLoading = true;
          this.service.postData({
            data: this.selected_items.map((item) => item.invoice_id),
            discount: this.discount,
            remark: this.remark,
            payment_id: this.payment_id,
            total_price: totalPriceSum,
            user_id: this.user.username,
          }, "invoice/update-invoice").then((result1: any) => {
            this.isLoading = false;
            Swal.fire({
              title: this.language.updated,
              text: '',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: true,
              timer: 2000
            }).then((result: any) => {
              debugger;
              const municipality_id = this.service.getDatabase().substring(0, 5);
              console.log(result);
              window.open(report_url + "print-bill-3x4?bill_id=" + result1.bill_id + "&municipality_id=" + municipality_id, "_blank");
              this.action = this.actions[0];
            })
          }, err => {
            Swal.fire({
              title: this.language.no_internet_alert,
              text: '',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2000
            });

            this.isLoading = false;
          })
        }
      });
    }
  }

  remove(item) {
    var index = -1;
    for (var i = 0; i < this.selected_items.length; i++) {
      if (this.selected_items[i].invoice_id == item.invoice_id) {
        index = i;
        break;
      }
    }
    if (index != -1) {
      this.selected_items.splice(index, 1);
    }
  }

  isFloat = value => !/^\s*$/.test(value) && !isNaN(value)
  trackByIndex(index) {
    return index;
  }

}
